// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2lRMR","disabled":"styles_disabled__KGnRW","backButton":"styles_backButton__Y8NHr","image":"styles_image__1km_G"};